import * as types from '@/store/mutation-types'
import * as api from '@/api'

const state = {
  searchMode: false,
  dynamicFilters: {
    'season': {
      active: false,
      value: '',
      label: 'season',
      placeholder: 'season',
      selected: '',
      list: '', // mapped from filters.js
      type: 'selectV2',
      key: 's',
      class: '',
      reset_filters: false,
      update_route: true,
      togglable: false
    },
    'gender': {
      active: false,
      selected: '',
      selectedLabel: '',
      label: 'gender',
      hideLabel: true,
      list: '', // mapped from filters.js,
      type: 'button',
      key: 'g',
      class: '',
      togglable: true,
      reset_filters: false,
      update_route: true,
      filtersReady: false // when all filters are ready
    },
    'color': {
      active: false,
      value: '',
      label: 'colors',
      key: 'c',
      selected: [],
      list: [], // mapped from filters.js
      type: 'color',
      class: '',
      mobile: true,
      default: []
    },
    'size': {
      active: false,
      value: '',
      label: 'sizes',
      key: 'sizes',
      selected: [],
      placeholder: 'sizes',
      list: [],
      listAdults: ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl', '4xl'],
      listKids: ['3y', '4y', '6y', '8y', '10y', '12y', '14y', '16y'],
      type: 'selectV2',
      multiple: false,
      boolean: false,
      class: '',
      default: [],
      togglable: true
    }
  },
  searchQuery: ''
}

// mutations
const mutations = {
  [types.SET_SEARCH_QUERY]: (state, payload) => {
    state.searchQuery = payload
  },
  [types.SET_SEARCH_FILTER]: (state, {key, value}) => {
    state.dynamicFilters[key].selected = value
  },
  /**
   * Set search filter with a list
   * @param state
   * @param filterName
   * @param query an object {key: value} where key is the searchable key in list item
   */
  [types.SET_SEARCH_LIST_FILTER]: (state, {filterName, query}) => {
    const filter = state.dynamicFilters[filterName]
    const queryKey = Object.keys(query)[0]
    const queryValue = query[queryKey]
    let matchItem = filter.list.find(item => item[queryKey] === queryValue)

    // reset filter if no result found
    if (!matchItem) {
      matchItem = {
        value: '',
        selectedLabel: ''
      }
    }
    filter.selected = matchItem.value
    filter.selectedLabel = matchItem.label
  },
  [types.SEARCH_MODE]: (state, payload) => {
    state.searchMode = payload
  },
  [types.MAP_SEARCH_FILTER]: (state, {key, payload}) => {
    state.dynamicFilters[key] = Object.assign(state.dynamicFilters[key], payload)
  }
}

const getters = {
  searchDynamicFilters: (state) => {
    return state.dynamicFilters
  },
  searchQuery: (state) => {
    return state.searchQuery
  },
  canSearch: (state) => {
    return state.searchQuery !== ''
  },
  urlParams: () => {
    return new URLSearchParams(window.location.search)
  },
  searchMode: state => !!state.searchMode,
  searchApiPayload: (state, getters) => ({
    q: getters.searchQuery,
    g: getters.searchDynamicFilters['gender'].selected,
    s: getters.searchDynamicFilters['season'].selected
  }),
  /**
   * Get filter name (key, actually) from the "key":"" value in filter object
   * @param state
   */
  searchFilterNameFromKey: (state) => (key) => {
    const filterNames = Object.keys(state.dynamicFilters)
    return filterNames.find(filterName => state.dynamicFilters[filterName].key === key)
  }
}

const actions = {
  /**
   * Map filters from filters vuex so the job hasn't to be done twice (with i18n)
   * @param store
   */
  mapFilters: (store, originalFilters) => {
    const searchFilterKeys = Object.keys(store.getters.searchDynamicFilters)

    searchFilterKeys.forEach(filterKey => {
      if (originalFilters[filterKey]) {
        store.commit(types.MAP_SEARCH_FILTER, {
          key: filterKey,
          payload: {
            list: originalFilters[filterKey].list
          }})
      }
    })
  },
  /**
   * Set dynamic params
   */
  searchDynamicFilters: (store) => {
    const urlParams = store.getters.urlParams

    const availableParams = Object.keys(store.getters.searchDynamicFilters)

    availableParams.forEach(param => {
      if (urlParams.get(param)) {
        store.commit(types.SET_SEARCH_FILTER, {key: param, value: urlParams.get(param)})
      }
    })
  },
  /**
   * Set query string
   * @param store
   */
  searchQuery: (store) => {
    const urlParams = store.getters.urlParams
    store.commit(types.SET_SEARCH_QUERY, urlParams.get('q'))
  },
  /**
   * Search main function
   * @param store
   */
  search: (store, gender) => {
    store.commit(types.SEARCH_MODE, true)
    store.dispatch('searchDynamicFilters')
    store.dispatch('searchQuery')
    store.dispatch('searchApiCall')
  },
  /**
   * Search api call
   */
  searchApiCall: (store) => {
    if (store.getters.canSearch) {
      store.commit(types.LOADING_PRODUCTS, true)
      api.fetchProducts(store.getters.searchApiPayload, productList => {
        store.commit(types.LOADING_PRODUCTS, false)
        store.commit(types.RECEIVE_PRODUCTS, productList)
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js